import { render, staticRenderFns } from "./CorpGovernanceSurvey.vue?vue&type=template&id=531429d8&"
import script from "./CorpGovernanceSurvey.vue?vue&type=script&lang=js&"
export * from "./CorpGovernanceSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports